<template>
  <nav>
    <div class="nav" :class="[listClass, rowClass]">
      <button type="button"
              class="user-select-none"
              v-if="isButtonClass" v-for="(item, index) in list"
              v-on:click="toggleActiveId(item[idName]);"
              :class="itemClass(item[idName])">
        {{item[titleName]}}
      </button>
      <a role="button"
         class="text-center user-select-none"
         v-if="!isButtonClass" v-for="(item, index) in list"
         v-on:click="toggleActiveId(item[idName]);"
         :class="itemClass(item[idName])">
        {{item[titleName]}}
      </a>
    </div>
  </nav>
</template>

<script>
  import { defineComponent } from "vue";

  export default defineComponent({
    props: {
      list: {
        type: Array,
      },
      listStyle: {
        type: String,
        default: null,
        validator: (val) => {
          return [null, "tabs", "pills", "rounded-pills"].includes(val);
        }
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      columns: {
        type: String,
        default: null,
        validator: (val) => {
          let reg = new RegExp(/^((sm-|md-|lg-|xl-|xxl-)[1-6])$|^[1-6]$/);
          let breakpoints = val.split(/\s/);
          breakpoints.forEach((e) => {
            if (reg.test(e) == false) return false;
          });
          return true;
        }
      },
      isEquallySpaced: {
        type: Boolean,
        default: null,
      },
      idName: {
        type: String,
        default: "id",
      },
      titleName: {
        type: String,
        default: "title",
      },
      selectedValue: {
        type: Number,
        default: null,
      },
      selectedValueList: {
        type: Array,
        default: null,
      },
    },
    computed: {
      listClass() {
        return {
          "nav-tabs": this.listStyle === "tabs",
          "nav-pills": this.listStyle === "pills",
          "nav-rounded-pills": this.listStyle === "rounded-pills",
        }
      },
      rowClass() {
        if (this.isEquallySpaced) {
          return "m-0 p-0 flex-nowrap";
        }
        if (this.columns != null) {
          let str = "m-0 p-0 row";
          let breakpoints = this.columns.split(/\s/);
          breakpoints.forEach((e) => {
            str += ` row-cols-${e}`;
          });
          return str;
        }
      },
      isButtonClass() {
        return this.listStyle === null;
      }
    },
    data: () => {
      return {
        status: {
          activeId: null,
          activeIdList: [],
        },
        activeIdList: [],
      }
    },
    methods: {
      itemClass(id) {
        return {
          "btn": this.listStyle === null,
          "btn-link": this.listStyle === null,
          "nav-link": this.listStyle === "tabs" || "pills",
          "col": this.columns != null && this.isEquallySpaced === false,
          "w-100": this.isEquallySpaced === true,
          "active": this.activeIdList.includes(id),
        }
      },
      toggleActiveId(id) {
        if (this.activeIdList.includes(id)) {
          this.activeIdList = this.activeIdList.filter((i) => i != id);
        } else {
          if (this.multiple) {
            this.activeIdList.push(id);
          } else {
            this.activeIdList = [id];
          }
        }
        this.updateStatus();
        this.$emit("select", this.status);
      },
      updateStatus() {
        if (this.multiple) {
          this.status.activeIdList = this.activeIdList;
          this.status.activeId = null;
        } else {
          this.status.activeIdList = null;
          this.status.activeId = this.activeIdList.length ? this.activeIdList[0] : null;
        }
      }
    },
    created() {
      if (this.multiple) {
        this.activeIdList = Array.isArray[this.selectedValueList] ? this.selectedValueList : [];
      } else {
        this.activeIdList = [this.selectedValue];
      }
      this.updateStatus();
    },
  });

</script>
